var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftIconShippingBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43766 3.56152C6.60825 3.56152 6.77902 3.6278 6.90902 3.75814L6.96631 3.81543C7.22697 4.0761 7.22697 4.49814 6.96631 4.75814L4.39079 7.33366H13.1043C13.4723 7.33366 13.771 7.63233 13.771 8.00033C13.771 8.36833 13.4723 8.66699 13.1043 8.66699H4.39079L6.96631 11.2425C7.22697 11.5032 7.22697 11.9252 6.96631 12.1852L6.90902 12.2425C6.64835 12.5032 6.22631 12.5032 5.96631 12.2425L2.19547 8.47168C1.93481 8.21101 1.93481 7.78897 2.19547 7.52897L5.96631 3.75814C6.09664 3.6278 6.26708 3.56152 6.43766 3.56152Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIconShippingBlack);
export default __webpack_public_path__ + "static/media/leftIconShippingBlack.f30e1f444f2f0d98db93261355325a8d.svg";
export { ForwardRef as ReactComponent };